import React, { useState } from 'react'
import check from '../assets/imgs/check-mark.png'
import { useAddress, useSDK, useSigner } from '@thirdweb-dev/react'
import { toast } from '../utils/toast'
import createSafetyCode from '../utils/getSafetyCode'

const Card3 = ({ mainAddr, burnerAddr, mainSign }) => {
  const [isDone, setIsDone] = useState(false)
  const address = useAddress()
  const thirdwebSdk = useSDK()
  const signer = useSigner()

  const handleConnect = async () => {
    try {
      if (address.toLowerCase() !== burnerAddr.toLowerCase()) {
        toast.error('Please connect to the burner wallet address')
        return
      }

      const provider = thirdwebSdk.getProvider()
      const safetyCode = createSafetyCode(provider)
      const sigText = await window.Voxlink.getVoxlinkString(
        mainAddr,
        burnerAddr,
        safetyCode
      )
      const burnerSign = await signer.signMessage(sigText)

      const registered = await window.Voxlink.registerVoxlink(
        mainAddr,
        burnerAddr,
        mainSign,
        burnerSign
      )

      if (registered) {
        await window.Voxlink.register.cancel()
        toast.success('Voxlink created successfully')
      }

      setIsDone(true)
    } catch (error) {
      if (error.reason === 'user rejected signing') {
        toast.error('Please sign the transaction to continue')
        return
      }
      if (error.reason === 'user rejected request') {
        toast.error('Please connect to the main wallet address to continue')
        return
      }
      toast.error(`${error.message}`)
    }
  }

  return (
    <>
      <div className={`Container_card`}>
        <div className="leftside_card">
          {isDone ? (
            <div className="left_top">
              <div className="step_tag">
                <h2>CONNECTED</h2>
              </div>
              <div className="connect_tag">
                <h1>
                  Voxlink Connected <br /> Succesfully
                </h1>
              </div>
            </div>
          ) : (
            <div className="left_top">
              <div className="step_tag">
                <h2>Step 3</h2>
              </div>
              <div className="connect_tag">
                <h1>
                  Connect Your Burner <br /> wallet
                  <div className="container-dots">
                    <span className="dot"></span>
                    <span className="dot "></span>
                    <span className="dot active"></span>
                  </div>
                </h1>
              </div>
            </div>
          )}

          <div className="end_next_step end_next_step-d">
            <div className="botton_top">
              <button
                className="button_box"
                onClick={() => {
                  window.location.reload()
                }}
              >
                Close
              </button>
            </div>
            <div className="botton_down">
              <a href="">How it works?</a>
            </div>
          </div>
        </div>
        <div className="rightside_card">
          <div className="rightside_card_p">
            {isDone ? (
              <p>Your assets are now safe!</p>
            ) : (
              <p>Connect your burner wallet and sign transaction</p>
            )}
          </div>
          <div className="connected_box">
            {isDone ? (
              <>
                <div>
                  <img src={check} />
                </div>
                <div>
                  <h1>Connected</h1>
                </div>
              </>
            ) : (
              <button className="connect_btn" onClick={handleConnect}>
                Connect Wallet
              </button>
            )}
          </div>
          <div className="address_section">
            <div className="">
              <p>Your burner wallet address is:</p>
            </div>

            <h5>{burnerAddr}</h5>
            <a href="">Not your address?</a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Card3
